import { LayoutSettings } from '@/config/layouts'
import CacheKey, { LOCAL_LANG_KEY_CLINIC } from '@/constants/cache-key'
import { type TagView } from '@/store/modules/tags-view'

/** 主题模块 - 储存 */
const DEFAULT_THEME_NAME = 'normal'
type DefaultThemeName = typeof DEFAULT_THEME_NAME
/** 注册的主题名称, 其中 DefaultThemeName 是必填的 */
export type ThemeName = DefaultThemeName | 'dark' | 'dark-blue'
// 正在应用的主题名称
export const getActiveThemeName = () => {
  return localStorage.getItem(CacheKey.ACTIVE_THEME_NAME) as ThemeName | null
}
export const setActiveThemeName = (themeName: ThemeName) => {
  localStorage.setItem(CacheKey.ACTIVE_THEME_NAME, themeName)
}

// 多语言 - 等级2
export const getCurrentLang = () => {
  return localStorage.getItem(LOCAL_LANG_KEY_CLINIC) || null
}
export const setCurrentLang = (lang: string) => {
  localStorage.setItem(LOCAL_LANG_KEY_CLINIC, lang)
}

// 系统布局配置
export const getConfigLayout = () => {
  const json = localStorage.getItem(CacheKey.CONFIG_LAYOUT)
  return json ? (JSON.parse(json) as LayoutSettings) : null
}
export const setConfigLayout = (settings: LayoutSettings) => {
  localStorage.setItem(CacheKey.CONFIG_LAYOUT, JSON.stringify(settings))
}
export const removeConfigLayout = () => {
  localStorage.removeItem(CacheKey.CONFIG_LAYOUT)
}

export const getCachedViews = () => {
  const json = localStorage.getItem(CacheKey.CACHED_VIEWS)
  return JSON.parse(json ?? '[]') as string[]
}
export const setCachedViews = (views: string[]) => {
  localStorage.setItem(CacheKey.CACHED_VIEWS, JSON.stringify(views))
}

// 标签栏
export const getVisitedViews = () => {
  const json = localStorage.getItem(CacheKey.VISITED_VIEWS)
  return JSON.parse(json ?? '[]') as TagView[]
}
export const setVisitedViews = (views: TagView[]) => {
  views.forEach((view) => {
    // 删除不必要的属性，防止 JSON.stringify 处理到循环引用
    delete view.matched
    delete view.redirectedFrom
  })
  localStorage.setItem(CacheKey.VISITED_VIEWS, JSON.stringify(views))
}

// 存储当前端可用菜单
export const getStaffMenuTree = () => {
  const json = localStorage.getItem('staffMenuTree')
  if (!json) return
  return JSON.parse(json)
}
export const setStaffMenuTree = (ui?: Record<string, any>) => {
  if (!ui) {
    localStorage.removeItem('staffMenuTree')
    return
  }
  localStorage.setItem('staffMenuTree', JSON.stringify(ui))
}

// 存储用户名称等信息
export const getUserInfo = () => {
  const json = localStorage.getItem('userInfo')
  if (!json) return
  return JSON.parse(json)
}
export const setUserInfo = (ui?: Record<string, any>) => {
  if (!ui) {
    localStorage.removeItem('userInfo')
    return
  }
  localStorage.setItem('userInfo', JSON.stringify(ui))
}

// 侧边栏状态
export const getSidebarStatus = () => {
  return localStorage.getItem(CacheKey.SIDEBAR_STATUS)
}
export const setSidebarStatus = (sidebarStatus: string) => {
  localStorage.setItem(CacheKey.SIDEBAR_STATUS, sidebarStatus)
}

// local存储token信息
export const getAccessToken = (key: string) => {
  const json = localStorage.getItem(key)
  if (!json) return
  return JSON.parse(json)
}
export const setAccessToken = (key: string, ui?: string) => {
  if (!ui) {
    localStorage.removeItem(key)
    return
  }
  localStorage.setItem(key, JSON.stringify(ui))
}
